import React from 'react';
import { LinkStatus } from '../../../../types/pilgrimGuide';
import { useLanguage } from '../../../../contexts/LanguageContext';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const StatusFilter = ({ value, onChange }: Props) => {
  const { translations } = useLanguage();

  const statuses: { value: LinkStatus; label: string }[] = [
    {
      value: 'approved',
      label: translations?.statusFilter?.approved || 'Approved',
    },
    {
      value: 'pending',
      label: translations?.statusFilter?.pending || 'Pending',
    },
    {
      value: 'rejected',
      label: translations?.statusFilter?.rejected || 'Rejected',
    },
    {
      value: 'disputed',
      label: translations?.statusFilter?.disputed || 'Disputed',
    },
  ];

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500"
    >
      <option value="">
        {translations?.statusFilter?.allStatuses || 'All Statuses'}
      </option>
      {statuses.map((status) => (
        <option key={status.value} value={status.value}>
          {status.label}
        </option>
      ))}
    </select>
  );
};
